export default [
  {
    title: "แผนประกันภัยอุบัติเหตุ",
    link: require("../../../static/pdf-template/Personal.pdf"),
    file_name: "ใบสมัครประกันอุบัติเหตุสำหรับคุณ.pdf"
  }
]